import { SHARED_MODE, SPECIAL_MODE, CONNECTION_STATUS } from '../../context/enums';

export const LABEL_DEACTIVATE = 'DEACTIVATE';
export const LABEL_ACTIVATE = 'ACTIVATE';

/**
 * Activate/deactivate button for the Dashboard control panel.
 * @param {{ isActive: boolean, systemStatus: Object|null, connectionStatus: string, isTestMode: boolean, onClick: Function }} props
 * @returns {JSX.Element}
 */
const ActivateButton = ({ isActive, systemStatus, connectionStatus, isTestMode, onClick }) => {
  const isDisabled =
    !systemStatus ||
    connectionStatus === CONNECTION_STATUS.DISCONNECTED ||
    systemStatus.sharedMode === SHARED_MODE.ACTIVATING ||
    systemStatus.sharedMode === SHARED_MODE.DEACTIVATING ||
    (systemStatus.sharedMode === SHARED_MODE.OFF && systemStatus.specialMode === SPECIAL_MODE.PRESOAKING) ||
    (systemStatus.sharedMode === SHARED_MODE.PRIMING && systemStatus.specialMode === SPECIAL_MODE.PRESOAKING);

  return (
    <button
      className={`activate-button-circular ${isActive ? 'active' : ''}`}
      onClick={onClick}
      disabled={isDisabled}
    >
      {isActive ? LABEL_DEACTIVATE : LABEL_ACTIVATE}
    </button>
  );
};

export default ActivateButton;
